import {
  TemplateIcon,
  ViewGridIcon,
  ArchiveIcon,
  CheckCircleIcon,
} from '@heroicons/react/outline'
import { Disclosure } from '@headlessui/react'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import gymSpaService from '../services/gym_spa.service';
import { useAuth } from '../middleware/auth.middleware';

let sideBarArray = [
  { name: 'Dashboard', icon: TemplateIcon, index: 0, href: '/dashboard/home' },
  { name: 'Terminé', icon: CheckCircleIcon, index: 1, href: '/dashboard/termine' },
  { name: 'En cours', icon: ViewGridIcon, index: 2, href: '/dashboard/en_cours' },
  { name: 'Rejeté', icon: ArchiveIcon, index: 3, href: '/dashboard/rejete' },
  { name: 'Attente', icon: ViewGridIcon, index: 4, href: '/dashboard/attente' },
]



function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}


const SidebarGymSpa = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {role} = useAuth();

  const [state, setState] = useState({
    open: false,
    parent: null
  })

  useQuery(['gymspa', role], gymSpaService.getGymspa, {})

  return (
    <div className="flex flex-col flex-grow border-r border-gray-200 pt-5 pb-4 bg-white overflow-y-auto">
      <div className="flex items-center flex-shrink-0 px-4">
        <img
          className="h-14 w-auto"
          src="/assets/logo.png"
          alt="ARPT-Resto"
        />
      </div>
      <div className="mt-5 flex-grow flex flex-col">
        <nav className="flex-1 px-2 space-y-1 bg-white" aria-label="Sidebar">
          {sideBarArray?.map((item) =>
            !item.children ? (
              <div key={item.name} className="group">
                <a
                  onClick={() => {
                    setState({...state, parent:null})
                    if (item.key === 'logout') {
                      setState({ ...state, open: !state.open })
                    } else
                      navigate(item.href)
                  }}
                  className={classNames(
                    item.href === location?.pathname
                      ? 'bg-rose-600  text-white'
                      : 'bg-white text-gray-600',
                    'group-hover:bg-rose-600 cursor-pointer group-hover:text-white duration-300 w-full flex items-center pl-2 py-2 text-sm font-medium rounded-full'
                  )}
                >

                  <button className={classNames(
                    item.href === location?.pathname ? 'bg-rose text-white' : 'text-gray-500',
                    "flex items-center justify-center w-10 h-10 group-hover:w-11 group-hover:h-11  duration-300 rounded-full mr-2  focus:outline-none group-hover:bg-rose group-hover:text-white"
                  )}>
                    <item.icon className='content-center flex-shrink-0 h-5 w-5' aria-hidden="true" />
                  </button>
                  <p className="group-hover:pl-2 duration-300">{item.name}</p>
                </a>
              </div>
            ) : (
              <Disclosure as="div" key={item.name} className="group space-y-1">
                {({ open }) => (
                  <>
                    <Disclosure.Button
                      className={classNames(
                        item.name === state.parent
                          ? 'bg-rose-600  text-purple-900'
                          : 'bg-white text-gray-600',
                        'group-hover:bg-rose-600  group-hover:text-white duration-300 w-full flex justify-between items-center pl-2 py-2 text-sm font-medium rounded-full'
                      )}
                    >
                      <div className="flex items-center">
                        <div className={classNames(
                          item.name === state.parent ? 'bg-rose text-white' : 'text-gray-500',
                          "flex items-center justify-center w-10 h-10 group-hover:w-11 group-hover:h-11  duration-300 rounded-full mr-2  focus:outline-none group-hover:bg-rose group-hover:text-white"
                        )}>
                          <item.icon className='content-center flex-shrink-0 h-5 w-5' aria-hidden="true" />
                        </div>
                        <p className="group-hover:pl-2 duration-300">{item.name}</p>
                      </div>
                      
                      <svg
                        className={classNames(
                          open ? 'text-purple-800 rotate-90' : 'text-gray-500',
                          'mr-3 flex-shrink-0 h-5 w-5 transform group-hover:text-purple-800 duration-700'
                        )}
                        viewBox="0 0 20 20"
                        aria-hidden="true">
                        <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                      </svg>
                    </Disclosure.Button>
                    <Disclosure.Panel className=" space-y-1">
                      {item.children.map((subItem) => (
                        <div
                          key={subItem.name}
                          onClick={() => { 
                            navigate(subItem.href)
                            setState({...state, parent: item.name})
                          }}
                        >
                          <div
                            as="a"
                            href=''
                            className="w-full flex cursor-pointer items-center pl-8 pr-2 py-2 hover:pl-1 hover:duration-300 duration-300 text-sm font-medium">
                            <div className="h-2 w-2 rounded-full mr-3 bg-purple-500 hover:bg-purple-500" />
                            <span className="hover:text-purple-500 text-gray-600">
                              {subItem.name}
                            </span>
                          </div>
                        </div>
                      ))}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            )
          )}
        </nav>
      </div>


      {/* <LogoutModal
        show={state.open}
        onClose={() => { setState({ ...state, open: !state.open }) }}
        logout={() => {
          setState({ ...state, open: !state.open })
          _useAuth.logout()
        }}
      /> */}
    </div>
  )
}

export default SidebarGymSpa